import React from 'react';
import { graphql } from 'gatsby';
import get from 'lodash/get';

import Layout from '../components/layout';
import Seo from '../components/seo';
import Hero from '../components/hero';
import Container from '../components/container';
import ArticlePreview from '../components/article-preview';
import GalleryPreview from '../components/gallery-preview';
import RulePreview from '../components/rule-preview';
import * as styles from './tag-page.module.css';

class TagPageTemplate extends React.Component {
  render() {
    const tag = get(this.props, 'pageContext.tag');
    const posts = get(this, 'props.data.allContentfulBlogPost.nodes') || [];
    const galleries = get(this, 'props.data.allContentfulGallery.nodes') || [];
    const rules = get(this, 'props.data.allContentfulRules.nodes') || [];

    const hasResults =
      posts.length > 0 || galleries.length > 0 || rules.length > 0;

    return (
      <Layout location={this.props.location}>
        <Seo
          title={`Tag: ${tag}`}
          description={`Posts tagged with ${tag}.`}
          pathname={this.props.location?.pathname}
        />
        <Hero
          title={`Tag: ${tag}`}
          content="All related blog, gallery, and rules content."
        />
        <div className={styles.container}>
          {!hasResults && (
            <Container>
              <p className={styles.empty}>
                No content has been tagged with this label yet.
              </p>
            </Container>
          )}

          {posts.length > 0 && (
            <section>
              <h2 className={styles.heading}>Blog Posts</h2>
              <ArticlePreview posts={posts} />
            </section>
          )}

          {galleries.length > 0 && (
            <section>
              <h2 className={styles.heading}>Galleries</h2>
              <GalleryPreview galleries={galleries} />
            </section>
          )}

          {rules.length > 0 && (
            <section>
              <h2 className={styles.heading}>Rules</h2>
              <RulePreview rules={rules} />
            </section>
          )}
        </div>
      </Layout>
    );
  }
}

export default TagPageTemplate;

export const pageQuery = graphql`
  query TagPageByTag($tag: String!) {
    allContentfulBlogPost(
      filter: { tags: { in: [$tag] } }
      sort: { fields: [publishedDate], order: DESC }
    ) {
      nodes {
        title
        slug
        publishedDate(formatString: "MMMM Do, YYYY")
        tags
        heroImage {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: BLURRED
            width: 424
            height: 212
          )
        }
        description
      }
    }
    allContentfulGallery(
      filter: { tags: { in: [$tag] } }
      sort: { fields: [title], order: ASC }
    ) {
      nodes {
        id
        title
        slug
        heroImage {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: BLURRED
            width: 424
            height: 212
          )
        }
      }
    }
    allContentfulRules(
      filter: { tags: { in: [$tag] } }
      sort: { fields: [publishedDate], order: DESC }
    ) {
      nodes {
        title
        slug
        publishedDate(formatString: "MMMM Do, YYYY")
        tags
        heroImage {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: BLURRED
            width: 424
            height: 212
          )
        }
      }
    }
  }
`;
